import api from './api';

export const designerService = {
  getAll: (params = {}) => api.get('/designers/', { params }),
  getById: (id) => api.get(`/designers/${id}`),
  create: (data) => api.post('/designers/', data),
  update: (id, data) => api.put(`/designers/${id}`, data),
  delete: (id) => api.delete(`/designers/${id}`),
};
